// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { wsc } from '../wsc';
import { FetchCompanyBillFilterResponseDto } from './dto/fetch-company-bill-filter-response.dto';
import { FetchCompanyBillQueryDto } from './dto/fetch-company-bill-query.dto';
import { FetchCompanyBillResponseDto } from './dto/fetch-company-bill-response.dto';
import { FetchCompanyGiftResponseDto } from './dto/fetch-company-gift-response.dto';
import { FetchCompanyTotalUsedResponseDto } from './dto/fetch-company-total-used-response.dto';

export class GiftLinePointModel {
  static fetchCompanyGift(): Promise<FetchCompanyGiftResponseDto> {
    return wsc.execute('/ws/gift-line-point/fetchCompanyGift') as any;
  }

  static fetchCompanyTotalUsed(): Promise<FetchCompanyTotalUsedResponseDto> {
    return wsc.execute('/ws/gift-line-point/fetchCompanyTotalUsed') as any;
  }

  static fetchCompanyBillFilter(): Promise<FetchCompanyBillFilterResponseDto> {
    return wsc.execute('/ws/gift-line-point/fetchCompanyBillFilter') as any;
  }

  static fetchCompanyBills(
    query: FetchCompanyBillQueryDto,
  ): Promise<FetchCompanyBillResponseDto> {
    return wsc.execute('/ws/gift-line-point/fetchCompanyBills', query) as any;
  }
}
// f9d16b7582b3516a50c809b3a9ab7f681eb442fce9c2eab05fd6a5ee9c90886a
